(() => {
  'use strict';
  const theme = window.theme = window.theme || {};
  const instances = new Map();
  const constructors = new Map();
  const mount = (root=document) => constructors.forEach((Constructor,type) => {
    const containers = [...root.querySelectorAll('[data-section-type="'+type+'"]')];
    if(root.matches?.('[data-section-type="'+type+'"]')) containers.unshift(root);
    containers.forEach(node => { if(!instances.has(node)) instances.set(node,new Constructor(node)); });
  });
  theme.sections = { register(type, Constructor) { constructors.set(type,Constructor); mount(); } };
  document.addEventListener('shopify:section:load',event=>mount(event.target));
  document.addEventListener('shopify:section:unload',event=>instances.forEach((value,node)=>{if(event.target.contains(node)){value.onUnload?.();instances.delete(node);}}));
  theme.Currency = {
    formatMoney(cents,format) {
      const token = (format || '{{amount}}').match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
      const noDecimals = token.includes('no_decimals');
      const comma = token.includes('comma_separator');
      const number = (Number(cents)/100).toLocaleString(comma?'de-DE':'en-US',{minimumFractionDigits:noDecimals?0:2,maximumFractionDigits:noDecimals?0:2});
      const html = (format || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/,number);
      const node=document.createElement('span');node.innerHTML=html;return node.textContent;
    },
    getBaseUnit(variant) {const u=variant.unit_price_measurement; return u?(u.reference_value===1?'':u.reference_value)+u.reference_unit:'';}
  };
  theme.Variants = class {
    constructor(options) {
      this.currentVariant=options.variants.find(v=>String(v.id)===options.container.querySelector(options.originalSelectorId)?.value);
      options.container.querySelectorAll(options.singleOptionSelector).forEach(input=>input.addEventListener('change',()=>{
        const values=[...options.container.querySelectorAll(options.singleOptionSelector)].filter(el=>el.tagName==='SELECT'||el.checked).map(el=>el.value);
        this.currentVariant=options.variants.find(v=>v.options.every((value,index)=>value===values[index]));
        const select=options.container.querySelector(options.originalSelectorId);if(select)select.value=this.currentVariant?.id||'';
        options.container.dispatchEvent(new CustomEvent('variantChange',{detail:{variant:this.currentVariant}}));
      }));
    }
  };
  theme.collapsibles={init(root){root.querySelectorAll('.collapsible-trigger').forEach(button=>{if(button.dataset.dawnCollapse)return;button.dataset.dawnCollapse='true';const panel=document.getElementById(button.getAttribute('aria-controls'));if(!panel)return;panel.hidden=button.getAttribute('aria-expanded')!=='true';button.addEventListener('click',()=>{const expanded=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!expanded));button.classList.toggle('is-open',!expanded);panel.hidden=expanded;panel.classList.toggle('is-open',!expanded);});});}};
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('.nikuya-pdp-01__zoom');if(!trigger)return;
    const img=trigger.closest('[data-nikuya-media-item]')?.querySelector('img');if(!img)return;
    const dialog=document.createElement('dialog');dialog.className='nikuya-media-dialog';
    const close=document.createElement('button');close.type='button';close.textContent=window.accessibilityStrings?.close||'Close';
    const image=img.cloneNode();image.removeAttribute('loading');image.sizes='100vw';dialog.append(close,image);document.body.append(dialog);
    close.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});dialog.addEventListener('close',()=>{dialog.remove();trigger.focus();},{once:true});dialog.showModal();close.focus();
  });
})();
(() => {
  const positionPopover=popover=>{
    const trigger=document.querySelector('[popovertarget="'+popover.id+'"]');if(!trigger)return;
    const rect=trigger.getBoundingClientRect();const width=Math.min(300,innerWidth-32);
    popover.style.left=Math.max(16,Math.min(innerWidth-width-16,rect.left+rect.width/2-width/2))+'px';
    popover.style.top=Math.max(16,Math.min(innerHeight-popover.offsetHeight-16,rect.bottom+12))+'px';
  };
  document.addEventListener('toggle',event=>{const popover=event.target;if(!popover.matches?.('.nikuya-shoppable-hero__popover'))return;if(event.newState==='open'){positionPopover(popover);popover.querySelector('a')?.focus();}else document.querySelector('[popovertarget="'+popover.id+'"]')?.focus();},true);
  addEventListener('resize',()=>document.querySelectorAll('.nikuya-shoppable-hero__popover:popover-open').forEach(positionPopover));
})();
(() => {
  const bindings=new Map();
  const initialize=(root=document)=>root.querySelectorAll('[data-nikuya-header]').forEach(header=>{
    if(bindings.has(header))return;
    const controller=new AbortController();const {signal}=controller;const timers=new Set();const finePointer=matchMedia('(min-width:990px) and (hover:hover) and (pointer:fine)');
    const enabled=()=>header.dataset.nikuyaHoverMenu==='true'&&finePointer.matches;
    const menus=[...header.querySelectorAll('header-menu')];
    menus.forEach(menu=>{
      const details=menu.querySelector('details'),summary=details?.querySelector('summary');if(!details||!summary)return;
      let dismissed=false,timer;
      const close=()=>{details.open=false;summary.setAttribute('aria-expanded','false');};
      menu.addEventListener('pointerenter',event=>{
        if(!enabled()||event.pointerType==='touch'||dismissed)return;
        clearTimeout(timer);
        menus.forEach(other=>{if(other!==menu&&!other.contains(document.activeElement)){const otherDetails=other.querySelector('details');if(otherDetails){otherDetails.open=false;otherDetails.querySelector('summary')?.setAttribute('aria-expanded','false');}}});
        details.open=true;summary.setAttribute('aria-expanded','true');
      },{signal});
      menu.addEventListener('pointerleave',()=>{
        dismissed=false;clearTimeout(timer);timer=setTimeout(()=>{timers.delete(timer);if(enabled()&&!menu.contains(document.activeElement))close();},150);timers.add(timer);
      },{signal});
      menu.addEventListener('keydown',event=>{
        if(event.key!=='Escape'||!details.open)return;event.preventDefault();event.stopPropagation();dismissed=true;close();summary.focus();
      },{signal});
    });
    bindings.set(header,()=>{controller.abort();timers.forEach(clearTimeout);});
  });
  initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:section:unload',event=>bindings.forEach((cleanup,header)=>{if(event.target.contains(header)){cleanup();bindings.delete(header);}}));
})();
